import React, { useState, useEffect } from 'react';
import { CaretRightOutlined, DeleteOutlined, PlusCircleOutlined, MinusCircleOutlined, ShoppingCartOutlined, BgColorsOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Row, Col, Card, Collapse, theme, Popconfirm, Button, Tooltip, Divider, Empty } from 'antd';
import { Link } from "react-router-dom";

const GetProductPersianName = (ProductEnName) => {
  var ProductPersianName = ""
  switch (ProductEnName) {
    case "MenTShirt":
      ProductPersianName = "تیشرت مردانه"
      break;
    case "MenCollarTShirt":
      ProductPersianName = "تیشرت یقه دار مردانه"
      break;
    case "MenShirt":
      ProductPersianName = "دورس مردانه"
      break;
    case "MenHoodie":
      ProductPersianName = "هودی مردانه"
      break;
    case "WomenTShirt":
      ProductPersianName = "تیشرت زنانه"
      break;
    case "WomenCollarTShirt":
      ProductPersianName = "تیشرت یقه دار زنانه"
      break;
    case "WomenShirt":
      ProductPersianName = "دورس زنانه"
      break;
    case "WomenHoodie":
      ProductPersianName = "هودی زنانه"
      break;
    case "WomenCropTShirt":
      ProductPersianName = "کراپ تیشرت زنانه"
      break;
    case "BoysTShirt":
      ProductPersianName = "تیشرت پسرانه"
      break;
    case "BoysCollarTShirt":
      ProductPersianName = "تیشرت یقه دار پسرانه"
      break;
    case "BoysShirt":
      ProductPersianName = "دورس پسرانه"
      break;
    case "BoysHoodie":
      ProductPersianName = "هودی پسرانه"
      break;
    case "GirlsTShirt":
      ProductPersianName = "تیشرت دخترانه"
      break;
    case "GirlsCollarTShirt":
      ProductPersianName = "تیشرت یقه دار دخترانه"
      break;
    case "GirlsShirt":
      ProductPersianName = "دورس دخترانه"
      break;
    case "GirlsHoodie":
      ProductPersianName = "هودی دخترانه"
      break;
    default:
      ProductPersianName = ProductEnName;
  }
  return ProductPersianName;
}

const GetProductPersianColor = (ProductEnColor) => {
  if (!ProductEnColor) return null;
  var ProductPersianColor = ""
  switch (ProductEnColor) {
    case "White":
      ProductPersianColor = "سفید"
      break;
    case "Black":
      ProductPersianColor = "سیاه"
      break;
    case "Grey":
      ProductPersianColor = "ملانژ"
      break;
    default:
      ProductPersianColor = ProductEnColor;
  }
  return ProductPersianColor;
}

const GetProductPersianQualityName = (ProductQualityNumber) => {
  if (!ProductQualityNumber) return null;
  var ProductQualityPerisan = ""
  switch (ProductQualityNumber) {
    case "1":
      ProductQualityPerisan = "معمولی"
      break;
    case "2":
      ProductQualityPerisan = "خوب"
      break;
    case "3":
      ProductQualityPerisan = "فوق العاده"
      break;
    default:
      ProductQualityPerisan = ProductQualityNumber;
  }
  return ProductQualityPerisan;
}

// Function to trigger cart update event for navbar badge
const triggerCartUpdate = () => {
  window.dispatchEvent(new Event('cartUpdated'));
};

const Cart = () => {
  const [productsTotalPrice, setProductsTotalPrice] = useState(0);
  const [designedOrders, setDesignedOrders] = useState([]);
  const [regularCart, setRegularCart] = useState([]);
  const [defaultActiveCollapseIndex, setDefaultActiveCollapseIndex] = useState([]);
  const [collapseItems, setCollapseItems] = useState([]);
  const [regularItems, setRegularItems] = useState([]);

  useEffect(() => {
    loadCarts();
  }, []);

  const loadCarts = () => {
    const designed = JSON.parse(localStorage.getItem('designedOrders')) || [];
    const regular = JSON.parse(localStorage.getItem('cart')) || [];
    setDesignedOrders(designed);
    setRegularCart(regular);
    getDesignedItems(designed);
    getRegularItems(regular);
    CalculateCartTotalPrice(designed, regular);
    
    if (designed.length > 0) {
      const keys = designed.map((_, index) => index.toString());
      setDefaultActiveCollapseIndex(keys);
    }
  };

  const increaseDesignedQuantity = (orderKey) => {
    const updatedOrders = [...designedOrders];
    const order = updatedOrders.find(order => order.Key === orderKey || order.key === orderKey);
    if (order) {
      order.Amount += 1;
      setDesignedOrders(updatedOrders);
      localStorage.setItem('designedOrders', JSON.stringify(updatedOrders));
      getDesignedItems(updatedOrders);
      CalculateCartTotalPrice(updatedOrders, regularCart);
      triggerCartUpdate();
    }
  };

  const decreaseDesignedQuantity = (orderKey) => {
    debugger
    const updatedOrders = [...designedOrders];
    const order = updatedOrders.find(order => order.Key === orderKey || order.key === orderKey);
    if (order && order.Amount > 1) {
      order.Amount -= 1;
      setDesignedOrders(updatedOrders);
      localStorage.setItem('designedOrders', JSON.stringify(updatedOrders));
      getDesignedItems(updatedOrders);
      CalculateCartTotalPrice(updatedOrders, regularCart);
      triggerCartUpdate();
    }
  };

  const increaseRegularQuantity = (itemId) => {
    const updatedCart = [...regularCart];
    const itemIndex = updatedCart.findIndex(item => item.id === itemId || item.productId === itemId);
    
    if (itemIndex !== -1) {
      updatedCart[itemIndex].quantity += 1;
      setRegularCart(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      getRegularItems(updatedCart);
      CalculateCartTotalPrice(designedOrders, updatedCart);
      triggerCartUpdate();
    }
  };
  
  const decreaseRegularQuantity = (itemId) => {
    const updatedCart = [...regularCart];
    const itemIndex = updatedCart.findIndex(item => item.id === itemId || item.productId === itemId);
    
    if (itemIndex !== -1 && updatedCart[itemIndex].quantity > 1) {
      updatedCart[itemIndex].quantity -= 1;
      setRegularCart(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      getRegularItems(updatedCart);
      CalculateCartTotalPrice(designedOrders, updatedCart);
      triggerCartUpdate();
    }
  };

  const CalculateCartTotalPrice = (designed = null, regular = null) => {
    const currentDesigned = designed !== null ? designed : designedOrders;
    const currentRegular = regular !== null ? regular : regularCart;
    
    let Total = 0;
    
    if (currentDesigned && currentDesigned.length > 0) {
      currentDesigned.forEach((item) => {
        const additionalCount = parseInt(JSON.parse(item.AdditionalDesignImage || '[]').length);
        Total = Total + (item.Amount * item.UnitPrice) + (additionalCount * 60000);
      });
    }
    
    if (currentRegular && currentRegular.length > 0) {
      currentRegular.forEach((item) => {
        Total = Total + (item.price * item.quantity);
      });
    }
    
    setProductsTotalPrice(Total);
  };

  const deleteDesignedDesign = (orderKey) => {
    const storedOrders = JSON.parse(localStorage.getItem('designedOrders')) || [];
    const UpdatedOrders = storedOrders.filter(order => order.Key !== orderKey && order.key !== orderKey);
    
    setDesignedOrders(UpdatedOrders);
    localStorage.setItem('designedOrders', JSON.stringify(UpdatedOrders));
    getDesignedItems(UpdatedOrders);
    CalculateCartTotalPrice(UpdatedOrders, regularCart);
    triggerCartUpdate();
  };

  const deleteRegularItem = (itemId) => {
    const UpdatedCart = regularCart.filter(item => (item.id !== itemId && item.productId !== itemId));
    
    setRegularCart(UpdatedCart);
    localStorage.setItem('cart', JSON.stringify(UpdatedCart));
    getRegularItems(UpdatedCart);
    CalculateCartTotalPrice(designedOrders, UpdatedCart);
    triggerCartUpdate();
  };

  const getDesignedItems = (orders = null) => {
    const currentOrders = orders !== null ? orders : designedOrders;
    
    if (!currentOrders || currentOrders.length === 0) {
      setCollapseItems([]);
      return;
    }
    
    const items = currentOrders.map((order, index) => {
      const orderKey = order.Key || order.key || index;
      const additionalCount = parseInt(JSON.parse(order.AdditionalDesignImage || '[]').length);
      const designFee = additionalCount * 60000;
      const baseTotal = order.Amount * order.UnitPrice;
      const itemTotal = baseTotal + designFee;
      
      return {
        key: orderKey.toString(),
        label: (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span className='font-2 fYekan-bold'>{GetProductPersianName(order.ProductName)}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PlusCircleOutlined 
                  onClick={(e) => {
                    e.stopPropagation();
                    increaseDesignedQuantity(orderKey);
                  }} 
                />
                <span className='pr-2 pl-2'>{order.Amount}</span>
                <MinusCircleOutlined 
                  onClick={(e) => {
                    e.stopPropagation();
                    decreaseDesignedQuantity(orderKey);
                  }} 
                  disabled={order.Amount === 1} 
                />
              </div>
              <Popconfirm 
                onConfirm={() => deleteDesignedDesign(orderKey)} 
                placement="bottom" 
                title="هشدار!" 
                description="آیا از حذف طراحی مطمئن هستید؟" 
                okText="حذف از سبد خرید!" 
                cancelText="لغو" 
                zIndex={29}
              >
                <DeleteOutlined 
                  style={{ color: "red" }} 
                  onClick={(e) => e.stopPropagation()} 
                />
              </Popconfirm>
            </div>
          </div>
        ),
        children: (
          <>
            <Row gutter={[64, 24]}>
              <Col className='mb-3' span={12} lg={8}>
                <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>نوع محصول</div>
                <div style={{ marginTop: "10px" }}>{GetProductPersianName(order.ProductName)}</div>
              </Col>
              {order.ProductColor && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>رنگ پارچه</div>
                  <div style={{ marginTop: "10px" }}>{GetProductPersianColor(order.ProductColor)}</div>
                </Col>
              )}
              {order.ProductSize && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>سایز</div>
                  <div style={{ marginTop: "10px" }}>{order.ProductSize}</div>
                </Col>
              )}
              {order.ProductQuality && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>کیفیت پارچه</div>
                  <div style={{ marginTop: "10px" }}>{GetProductPersianQualityName(order.ProductQuality)}</div>
                </Col>
              )}
              <Col className='mb-3' span={12} lg={8}>
                <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>تعداد عکس اضافه شده</div>
                <div style={{ marginTop: "10px" }}>{additionalCount} عدد</div>
              </Col>
            </Row>
            
            <Divider orientation="center" style={{ margin: '16px 0', borderColor: '#a23854' }}>
              <span style={{ color: '#a23854', fontSize: '14px' }}>جزئیات قیمت</span>
            </Divider>
            
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div style={{ background: 'rgba(162,56,84,0.05)', padding: '12px', borderRadius: '8px' }}>
                  <Row>
                    <Col span={12}>
                      <span>قیمت پایه هر عدد:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{order.UnitPrice.toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>تعداد:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{order.Amount} عدد</span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>قیمت کل پایه:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{baseTotal.toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                  <Divider style={{ margin: '8px 0' }} />
                  <Row>
                    <Col span={12}>
                      <span>هزینه طراحی هر عکس:</span>
                      <Tooltip title="هزینه اضافه کردن هر عکس به طرح شما">
                        <InfoCircleOutlined style={{ marginRight: '4px', color: '#a23854' }} />
                      </Tooltip>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>60,000 تومان</span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>تعداد عکس اضافه شده:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{additionalCount} عدد</span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>هزینه کل طراحی:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{designFee.toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                  <Divider style={{ margin: '8px 0' }} />
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>جمع کل این آیتم:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span style={{ color: '#a23854', fontSize: '16px' }}>{itemTotal.toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </>
        ),
        style: panelStyle,
      };
    });
    
    setCollapseItems(items);
  };

  const getRegularItems = (cart = null) => {
    const currentCart = cart !== null ? cart : regularCart;
    
    if (!currentCart || currentCart.length === 0) {
      setRegularItems([]);
      return;
    }
    
    const items = currentCart.map((item, index) => {
      const itemId = item.id || item.productId || index;
      
      return {
        key: itemId.toString(),
        label: (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span className='font-2 fYekan-bold'>{item.title}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PlusCircleOutlined 
                  onClick={(e) => {
                    e.stopPropagation();
                    increaseRegularQuantity(itemId);
                  }} 
                />
                <span className='pr-2 pl-2'>{item.quantity}</span>
                <MinusCircleOutlined 
                  onClick={(e) => {
                    e.stopPropagation();
                    decreaseRegularQuantity(itemId);
                  }} 
                  disabled={item.quantity === 1} 
                />
              </div>
              <Popconfirm 
                onConfirm={() => deleteRegularItem(itemId)} 
                placement="bottom" 
                title="هشدار!" 
                description="آیا از حذف محصول مطمئن هستید؟" 
                okText="حذف از سبد خرید!" 
                cancelText="لغو" 
                zIndex={29}
              >
                <DeleteOutlined 
                  style={{ color: "red" }} 
                  onClick={(e) => e.stopPropagation()} 
                />
              </Popconfirm>
            </div>
          </div>
        ),
        children: (
          <>
            <Row gutter={[64, 24]}>
              <Col className='mb-3' span={12} lg={8}>
                <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>نوع محصول</div>
                <div style={{ marginTop: "10px" }}>{item.title}</div>
              </Col>
              {item.variant?.color && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>رنگ</div>
                  <div style={{ marginTop: "10px" }}>{item.variant.color}</div>
                </Col>
              )}
              {item.variant?.quality && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>کیفیت</div>
                  <div style={{ marginTop: "10px" }}>{item.variant.quality}</div>
                </Col>
              )}
              {item.variant?.size && (
                <Col className='mb-3' span={12} lg={8}>
                  <div style={{ borderBottom: "2px solid purple", paddingBottom: "5px" }}>سایز</div>
                  <div style={{ marginTop: "10px" }}>{item.variant.size}</div>
                </Col>
              )}
            </Row>
            
            <Divider orientation="center" style={{ margin: '16px 0', borderColor: '#a23854' }}>
              <span style={{ color: '#a23854', fontSize: '14px' }}>جزئیات قیمت</span>
            </Divider>
            
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div style={{ background: 'rgba(162,56,84,0.05)', padding: '12px', borderRadius: '8px' }}>
                  <Row>
                    <Col span={12}>
                      <span>قیمت واحد:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{item.price.toLocaleString()} تومان</span>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <span>تعداد:</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <span>{item.quantity} عدد</span>
                    </Col>
                  </Row>
                  <Divider style={{ margin: '8px 0' }} />
                  <Row style={{ marginTop: '8px' }}>
                    <Col span={12}>
                      <strong>جمع کل این آیتم:</strong>
                    </Col>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      <strong style={{ color: '#a23854', fontSize: '16px' }}>{(item.price * item.quantity).toLocaleString()} تومان</strong>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </>
        ),
        style: panelStyle,
      };
    });
    
    setRegularItems(items);
  };
  
  const { token } = theme.useToken();

  const panelStyle = {
    fontWeight: "normal",
    marginBottom: 24,
    background: "-moz-linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
    background: "-webkit-linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
    background: "linear-gradient(31deg, rgba(226,163,163,1) 5%, rgba(193,172,238,1) 95%)",
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  const hasItems = (designedOrders && designedOrders.length > 0) || (regularCart && regularCart.length > 0);
  
  const vatAmount = Math.floor(productsTotalPrice * 0.1);
  const finalTotal = productsTotalPrice + vatAmount;

  return (
    <Row align={"center"}>
      <Col span={24} style={{ maxWidth: "1200px" }}>
        <Card className="fEstedad light-glass-effect-card shaped-border" title="سبد خرید">
          {!hasItems ? (
            <Empty 
              description="سبد خرید شما خالی است!" 
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              style={{ padding: '40px 0' }}
            />
          ) : (
            <>
              {/* Designed Products Section */}
              {(designedOrders && designedOrders.length > 0) && (
                <>
                  <div style={{ 
                    background: 'linear-gradient(135deg, rgba(162,56,84,0.1) 0%, rgba(162,56,84,0.05) 100%)',
                    padding: '12px 20px',
                    borderRadius: '12px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <BgColorsOutlined style={{ fontSize: '24px', color: '#a23854' }} />
                    <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#a23854' }}>
                      محصولات طراحی شده
                    </span>
                    <span style={{ 
                      background: '#a23854', 
                      color: 'white', 
                      borderRadius: '20px',
                      padding: '2px 10px',
                      fontSize: '14px'
                    }}>
                      {designedOrders.length} آیتم
                    </span>
                  </div>
                  
                  <Collapse
                    bordered={false}
                    defaultActiveKey={defaultActiveCollapseIndex}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 180} />}
                    style={{ background: "none" }}
                    items={collapseItems}
                  />
                </>
              )}
              
              {/* Separator between sections */}
              {(designedOrders && designedOrders.length > 0) && (regularCart && regularCart.length > 0) && (
                <Divider style={{ margin: '32px 0', borderColor: '#a23854', borderWidth: '2px' }} />
              )}
              
              {/* Regular Products Section */}
              {(regularCart && regularCart.length > 0) && (
                <>
                  <div style={{ 
                    background: 'linear-gradient(135deg, rgba(162,56,84,0.1) 0%, rgba(162,56,84,0.05) 100%)',
                    padding: '12px 20px',
                    borderRadius: '12px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <ShoppingCartOutlined style={{ fontSize: '24px', color: '#a23854' }} />
                    <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#a23854' }}>
                      محصولات آماده
                    </span>
                    <span style={{ 
                      background: '#a23854', 
                      color: 'white', 
                      borderRadius: '20px',
                      padding: '2px 10px',
                      fontSize: '14px'
                    }}>
                      {regularCart.length} آیتم
                    </span>
                  </div>
                  
                  <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 180} />}
                    style={{ background: "none" }}
                    items={regularItems}
                  />
                </>
              )}
              
              {/* Cart Summary */}
              <Divider style={{ margin: '32px 0 24px 0', borderColor: '#a23854' }} />
              
              <div style={{ 
                background: 'rgba(162,56,84,0.1)', 
                padding: '24px', 
                borderRadius: '16px',
                border: '1px solid rgba(162,56,84,0.2)'
              }}>
                <Row>
                  <Col span={12}>
                    <span className='font-3'>جمع کل محصولات:</span>
                  </Col>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    <span className='font-5' style={{ color: '#a23854', fontWeight: 'bold' }}>
                      {productsTotalPrice.toLocaleString("en-US")} <span className='font-3'>تومان</span>
                    </span>
                  </Col>
                </Row>
                <Row style={{ marginTop: 12 }}>
                  <Col span={12}>
                    <span className='font-3'>مالیات بر ارزش افزوده (10%):</span>
                  </Col>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    <span className='font-4'>+ {vatAmount.toLocaleString("en-US")} تومان</span>
                  </Col>
                </Row>
                <Divider style={{ margin: '16px 0' }} />
                <Row>
                  <Col span={12}>
                    <strong className='font-3' style={{ fontSize: '16px' }}>قابل پرداخت:</strong>
                  </Col>
                  <Col span={12} style={{ textAlign: 'left' }}>
                    <strong className='font-5' style={{ color: '#a23854', fontSize: '24px' }}>
                      {finalTotal.toLocaleString("en-US")} <span className='font-3'>تومان</span>
                    </strong>
                  </Col>
                </Row>
              </div>
            </>
          )}
          
          <Row className='mt-4' gutter={[24, 24]} style={{ flex: 1, alignItems: 'center' }}>
            <Col align={"center"} span={24} md={12}>
              <Link to="/choose-product">
                <Button color="text" variant="outlined" size="large">افزودن طراحی دیگر</Button>
              </Link>
            </Col>
            <Col align={"center"} span={24} md={12}>
              <Link to={hasItems ? "/checkout" : "/cart"}>
                <Button disabled={!hasItems} type="primary" size="large" style={{ minWidth: 160 }}>
                  ادامه جهت خرید
                </Button>
              </Link>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default Cart;